// src/portal-app/shell/kit/StatusBadge.js
//
// Small status pill with color coding. Cross-cutting by definition (spec
// §6) — moved here from operations/kit.js (Plan 4 Task 1). Class names
// (.opk-*) kept byte-identical; rules moved into kitCss.js.
//
// Default tone by status: open->green, closed->muted, cancelled->red,
// flagged->amber. Explicit tone prop overrides the default.
import React from 'react';
import { ensureKitCss } from './kitCss';

const DEFAULT_TONE = {
    open: 'green',
    closed: 'muted',
    cancelled: 'red',
    flagged: 'amber',
    pending: 'blue',
    active: 'green',
    void: 'red',
    voided: 'red',
};

// props:
//   status  string  e.g. 'open', 'closed', 'cancelled', 'flagged'
//   label   string  translated label text
//   tone    string  'green'|'red'|'amber'|'muted'|'blue'
export function StatusBadge({ status, label, tone }) {
    ensureKitCss();
    const resolvedTone = tone || DEFAULT_TONE[status] || 'muted';
    return (
        <span
            className={`opk-badge opk-badge-${resolvedTone}`}
            data-testid="status-badge"
        >
            {label}
        </span>
    );
}

export default StatusBadge;
